import { Component, Vue } from 'vue-property-decorator';
import { WeightsStateModel, setWeights, updateEditWeight, removeWeight } from '@/store/WeightsStore/models';
import { Weight } from '@/models/interfaces';
import { toggleAddWeight } from '@/store/UIStore/models';

@Component
export default class WeightHistory extends Vue {
  public dialog = false;
  public headers = [
    {
      text: 'Date',
      align: 'center',
      sortable: true,
      value: 'date',
    },
    { text: 'Amount', value: 'amount', align: 'center' },
    { text: 'Actions', value: 'action', sortable: false, align: 'center' },
  ];

  get weights() {
    return (this.$store.state.WeightsStore as WeightsStateModel).weights;
  }

  mounted(): void {
    this.$store.dispatch(setWeights);
  }

  editItem(item: any) {
    const editedIndex = this.weights.indexOf(item);
    const weight: Weight = {
      ...item,
      index: editedIndex
    };
    this.$store.dispatch(updateEditWeight, weight);
    this.$store.dispatch(toggleAddWeight, true);
  }

  addItem() {
    this.$store.dispatch(toggleAddWeight, true);
  }

  deleteItem(item: Weight) {
    this.$store.dispatch(removeWeight, item);
  }
}
